import Link from 'next/link'
import classnames from 'classnames'

import Wrapper from 'components/saquon/wrapper'
import SectionFooterSeparator from 'components/saquon/section-footer-separator'
import Dots from 'components/saquon/dots'
import { Button, Typography } from '~ui'
import { useScreenClass } from '~hooks'

import styles from './MainSection.module.scss'

const { Text } = Typography

const MainSection = () => {
  const { isMobile } = useScreenClass()

  return (
    <section id={isMobile ? 'main' : null} style={{ overflow: 'hidden' }}>
      <Wrapper>
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.background}>
              <Dots id={styles['dots-2']} type="circle" className={styles['dots-2']} />
            </div>

            <div className={styles.description}>
              <Text size="lg" color="g-white" bold>
                The Ultimate NY Giants Experience with
              </Text>
              <h1 className={styles.title}>Saquon Barkley</h1>
              <Text color="g-white" size="lg">
                Bid on an unforgettable experience with the incomparable New York Giants Running
                Back, Saquon Barkley, and receive a limited edition SB Rookie NFT, exclusively
                provided on Granted. The best part? A portion of all proceeds benefits the Michael
                Ann & Saquon Barkley Hope Foundation.
              </Text>

              <div className={styles.bottom}>
                <Text color="g-white" size="lg">
                  Choose your experience type:
                </Text>
                <div className={styles.buttons}>
                  <Link legacyBehavior href="#legacy">
                    <a>
                      <Button variant="primary" tabIndex={-1} fluid>
                        Legacy
                      </Button>
                    </a>
                  </Link>
                  <Link legacyBehavior href="#gameday">
                    <a>
                      <Button variant="primary" tabIndex={-1} fluid>
                        Gameday
                      </Button>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.right}>
            <Dots id={styles['dots-1']} type="circle" className={styles['dots-1']} />
            <div className={classnames(styles.video, styles['hard-shadow'])}>
              <iframe
                title="Saquon Barkley Drop Announcement"
                src="https://player.vimeo.com/video/551605674?autoplay=1&loop=1&color=00FFAa&title=0&byline=0&portrait=0&muted=1"
                allow="autoplay; fullscreen; picture-in-picture"
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </Wrapper>
      <SectionFooterSeparator />
    </section>
  )
}

export default MainSection
